// Mocaverse NFT data
   export const DeGodsNFTs = [
  
  {
    "id": "degods-4247",
    "name": "DeGods #4247",
    "image": "https://metadata.degods.com/g/4247-dead-rm.png",
    "price": "1.85 ETH"
  },
  {
    "id": "degods-3379",
    "name": "DeGods #3379", 
    "image": "https://metadata.degods.com/g/3379-dead-rm.png",
    "price": "0.95 ETH"
  },
  {
    "id": "degods-4866",
    "name": "DeGods #4866",
    "image": "https://metadata.degods.com/g/4866-dead-rm.png",
    "price": "1.45 ETH"
  },
  {
    "id": "degods-2876",
    "name": "DeGods #2876",
    "image": "https://metadata.degods.com/g/2876-dead-rm.png",
    "price": "0.88 ETH"
  },
  {
    "id": "degods-5006",
    "name": "DeGods #5006",
    "image": "https://metadata.degods.com/g/5006-dead-rm.png",
    "price": "1.92 ETH"
  },
  {
    "id": "degods-9195",
    "name": "DeGods #9195",
    "image": "https://metadata.degods.com/g/9195-dead-rm.png",
    "price": "1.15 ETH"
  },
  {
    "id": "degods-3148",
    "name": "DeGods #3148",
    "image": "https://metadata.degods.com/g/3148-dead-rm.png",
    "price": "0.79 ETH"
  },
  {
    "id": "degods-3647",
    "name": "DeGods #3647",
    "image": "https://metadata.degods.com/g/3647-dead-rm.png",
    "price": "1.68 ETH"
  },
  {
    "id": "degods-2891",
    "name": "DeGods #2891",
    "image": "https://metadata.degods.com/g/2891-dead-rm.png",
    "price": "1.25 ETH"
  },
  {
    "id": "degods-5641",
    "name": "DeGods #5641",
    "image": "https://metadata.degods.com/g/5641-dead-rm.png",
    "price": "0.92 ETH"
  },
  {
    "id": "degods-4876",
    "name": "DeGods #4876",
    "image": "https://metadata.degods.com/g/4876-dead-rm.png",
    "price": "1.78 ETH"
  },
  {
    "id": "degods-2300",
    "name": "DeGods #2300",
    "image": "https://metadata.degods.com/g/2300-dead-rm.png",
    "price": "1.35 ETH"
  },
  {
    "id": "degods-84",
    "name": "DeGods #84",
    "image": "https://metadata.degods.com/g/84-dead-rm.png",
    "price": "0.85 ETH"
  },
  {
    "id": "degods-7418",
    "name": "DeGods #7418",
    "image": "https://metadata.degods.com/g/7418-dead.png",
    "price": "1.95 ETH"
  },
  {
    "id": "degods-6485",
    "name": "DeGods #6485",
    "image": "https://metadata.degods.com/g/6485-dead-rm.png",
    "price": "1.42 ETH"
  },
  {
    "id": "degods-721",
    "name": "DeGods #721",
    "image": "https://metadata.degods.com/g/721-dead.png",
    "price": "0.98 ETH"
  },
  {
    "id": "degods-7195",
    "name": "DeGods #7195",
    "image": "https://metadata.degods.com/g/7195-s3-male.png",
    "price": "1.88 ETH"
  },
  {
    "id": "degods-2468",
    "name": "DeGods #2468",
    "image": "https://metadata.degods.com/g/2468-dead.png",
    "price": "1.15 ETH"
  },
  {
    "id": "degods-4511",
    "name": "DeGods #4511",
    "image": "https://metadata.degods.com/g/4511-dead-rm.png",
    "price": "0.82 ETH"
  },
  {
    "id": "degods-9599",
    "name": "DeGods #9599",
    "image": "https://metadata.degods.com/g/9599.png",
    "price": "1.72 ETH"
  },
  {
    "id": "degods-1181",
    "name": "DeGods #1181",
    "image": "https://metadata.degods.com/g/1181-dead-rm.png",
    "price": "1.28 ETH"
  },
  {
    "id": "degods-8592",
    "name": "DeGods #8592",
    "image": "https://metadata.degods.com/g/8592-dead-rm.png",
    "price": "0.75 ETH"
  },
  {
    "id": "degods-7514",
    "name": "DeGods #7514",
    "image": "https://metadata.degods.com/g/7514.png",
    "price": "2.15 ETH"
  },
  {
    "id": "degods-5288",
    "name": "DeGods #5288",
    "image": "https://metadata.degods.com/g/5288-dead.png",
    "price": "1.55 ETH"
  },
  {
    "id": "degods-2546",
    "name": "DeGods #2546",
    "image": "https://metadata.degods.com/g/2546-dead-rm.png",
    "price": "0.95 ETH"
  },
  {
    "id": "degods-3128",
    "name": "DeGods #3128",
    "image": "https://metadata.degods.com/g/3128-dead-rm.png",
    "price": "1.82 ETH"
  },
  {
    "id": "degods-4597",
    "name": "DeGods #4597",
    "image": "https://metadata.degods.com/g/4597-dead-rm.png",
    "price": "1.35 ETH"
  },
  {
    "id": "degods-3116",
    "name": "DeGods #3116",
    "image": "https://metadata.degods.com/g/3116-dead-rm.png",
    "price": "0.88 ETH"
  },
  {
    "id": "degods-3098",
    "name": "DeGods #3098",
    "image": "https://metadata.degods.com/g/3098-dead-rm.png",
    "price": "1.65 ETH"
  },
  {
    "id": "degods-9679",
    "name": "DeGods #9679",
    "image": "https://metadata.degods.com/g/9679-dead-rm.png",
    "price": "1.18 ETH"
  },
  {
    "id": "degods-7673",
    "name": "DeGods #7673",
    "image": "https://metadata.degods.com/g/7673-dead-rm.png",
    "price": "0.92 ETH"
  },
  {
    "id": "degods-6144",
    "name": "DeGods #6144",
    "image": "https://metadata.degods.com/g/6144-dead-rm.png",
    "price": "1.95 ETH"
  },
  {
    "id": "degods-8794",
    "name": "DeGods #8794",
    "image": "https://metadata.degods.com/g/8794-dead-rm.png",
    "price": "1.48 ETH"
  },
  {
    "id": "degods-3028",
    "name": "DeGods #3028",
    "image": "https://metadata.degods.com/g/3028-dead-rm.png",
    "price": "0.85 ETH"
  },
  {
    "id": "degods-7812",
    "name": "DeGods #7812",
    "image": "https://metadata.degods.com/g/7812-dead-rm.png",
    "price": "1.75 ETH"
  },
  {
    "id": "degods-7380",
    "name": "DeGods #7380",
    "image": "https://metadata.degods.com/g/7380-dead-rm.png",
    "price": "1.25 ETH"
  },
  {
    "id": "degods-9397",
    "name": "DeGods #9397",
    "image": "https://metadata.degods.com/g/9397-dead-rm.png",
    "price": "0.78 ETH"
  },
  {
    "id": "degods-5852",
    "name": "DeGods #5852",
    "image": "https://metadata.degods.com/g/5852-dead-rm.png",
    "price": "2.1 ETH"
  },
  {
    "id": "degods-1357",
    "name": "DeGods #1357",
    "image": "https://metadata.degods.com/g/1357-dead-rm.png",
    "price": "1.58 ETH"
  },
  {
    "id": "degods-8207",
    "name": "DeGods #8207",
    "image": "https://metadata.degods.com/g/8207-dead-rm.png",
    "price": "0.95 ETH"
  },
  {
    "id": "degods-2009",
    "name": "DeGods #2009",
    "image": "https://metadata.degods.com/g/2009-dead-rm.png",
    "price": "1.85 ETH"
  },
  {
    "id": "degods-9425",
    "name": "DeGods #9425",
    "image": "https://metadata.degods.com/g/9425-dead-rm.png",
    "price": "1.32 ETH"
  },
  {
    "id": "degods-3876",
    "name": "DeGods #3876",
    "image": "https://metadata.degods.com/g/3876-dead-rm.png",
    "price": "0.72 ETH"
  },
  {
    "id": "degods-8787",
    "name": "DeGods #8787",
    "image": "https://metadata.degods.com/g/8787-dead-rm.png",
    "price": "1.68 ETH"
  },
  {
    "id": "degods-4370",
    "name": "DeGods #4370",
    "image": "https://metadata.degods.com/g/4370-dead-rm.png",
    "price": "1.22 ETH"
  },
  {
    "id": "degods-5945",
    "name": "DeGods #5945",
    "image": "https://metadata.degods.com/g/5945-dead-rm.png",
    "price": "0.85 ETH"
  },
  {
    "id": "degods-9017",
    "name": "DeGods #9017",
    "image": "https://metadata.degods.com/g/9017-s3-male.png",
    "price": "2.05 ETH"
  },
  {
    "id": "degods-8684",
    "name": "DeGods #8684",
    "image": "https://metadata.degods.com/g/8684-dead-rm.png",
    "price": "1.45 ETH"
  },
  {
    "id": "degods-2890",
    "name": "DeGods #2890",
    "image": "https://metadata.degods.com/g/2890-dead-rm.png",
    "price": "0.92 ETH"
  },
  {
    "id": "degods-3014",
    "name": "DeGods #3014",
    "image": "https://metadata.degods.com/g/3014-dead-rm.png",
    "price": "1.78 ETH"
  },
  {
    "id": "degods-8438",
    "name": "DeGods #8438",
    "image": "https://metadata.degods.com/g/8438-dead-rm.png",
    "price": "1.35 ETH"
  },
  {
    "id": "degods-8237",
    "name": "DeGods #8237",
    "image": "https://metadata.degods.com/g/8237-dead-rm.png",
    "price": "0.82 ETH"
  },
  {
    "id": "degods-4761",
    "name": "DeGods #4761",
    "image": "https://metadata.degods.com/g/4761-dead-rm.png",
    "price": "1.92 ETH"
  },
       
  {
    "id": "degods-83",
    "name": "DeGods #83",
    "image": "https://metadata.degods.com/g/83-dead-rm.png",
    "price": "1.45 ETH"
  },
  {
    "id": "degods-5735",
    "name": "DeGods #5735",
    "image": "https://metadata.degods.com/g/5735-dead-rm.png",
    "price": "0.95 ETH"
  },
  {
    "id": "degods-610",
    "name": "DeGods #610",
    "image": "https://metadata.degods.com/g/610-dead-rm.png",
    "price": "1.85 ETH"
  },
  {
    "id": "degods-6876",
    "name": "DeGods #6876",
    "image": "https://metadata.degods.com/g/6876-dead-rm.png",
    "price": "1.25 ETH"
  },
  {
    "id": "degods-217",
    "name": "DeGods #217",
    "image": "https://metadata.degods.com/g/217-s3-male.png",
    "price": "2.15 ETH"
  },
  {
    "id": "degods-4691",
    "name": "DeGods #4691",
    "image": "https://metadata.degods.com/g/4691-dead-rm.png",
    "price": "0.85 ETH"
  },
  {
    "id": "degods-6238",
    "name": "DeGods #6238",
    "image": "https://metadata.degods.com/g/6238-dead-rm.png",
    "price": "1.65 ETH"
  },
  {
    "id": "degods-3588",
    "name": "DeGods #3588",
    "image": "https://metadata.degods.com/g/3588-dead-rm.png",
    "price": "1.15 ETH"
  },
  {
    "id": "degods-9426",
    "name": "DeGods #9426",
    "image": "https://metadata.degods.com/g/9426-dead-rm.png",
    "price": "0.78 ETH"
  },
  {
    "id": "degods-3493",
    "name": "DeGods #3493",
    "image": "https://metadata.degods.com/g/3493-dead-rm.png",
    "price": "1.95 ETH"
  },
  {
    "id": "degods-8190",
    "name": "DeGods #8190",
    "image": "https://metadata.degods.com/g/8190-dead-rm.png",
    "price": "1.35 ETH"
  },
  {
    "id": "degods-7068",
    "name": "DeGods #7068",
    "image": "https://metadata.degods.com/g/7068-dead-rm.png",
    "price": "0.92 ETH"
  },
  {
    "id": "degods-9422",
    "name": "DeGods #9422",
    "image": "https://metadata.degods.com/g/9422-dead-rm.png",
    "price": "1.75 ETH"
  },
  {
    "id": "degods-6595",
    "name": "DeGods #6595",
    "image": "https://metadata.degods.com/g/6595-dead-rm.png",
    "price": "1.28 ETH"
  },
  {
    "id": "degods-2198",
    "name": "DeGods #2198",
    "image": "https://metadata.degods.com/g/2198-dead-rm.png",
    "price": "0.88 ETH"
  },
  {
    "id": "degods-2678",
    "name": "DeGods #2678",
    "image": "https://metadata.degods.com/g/2678-dead.png",
    "price": "2.05 ETH"
  },
  {
    "id": "degods-2742",
    "name": "DeGods #2742",
    "image": "https://metadata.degods.com/g/2742-dead-rm.png",
    "price": "1.48 ETH"
  },
  {
    "id": "degods-8035",
    "name": "DeGods #8035",
    "image": "https://metadata.degods.com/g/8035-dead.png",
    "price": "1.05 ETH"
  },
  {
    "id": "degods-5309",
    "name": "DeGods #5309",
    "image": "https://metadata.degods.com/g/5309-dead-rm.png",
    "price": "0.75 ETH"
  },
  {
    "id": "degods-1473",
    "name": "DeGods #1473",
    "image": "https://metadata.degods.com/g/1473-dead-rm.png",
    "price": "1.88 ETH"
  },
  {
    "id": "degods-5260",
    "name": "DeGods #5260",
    "image": "https://metadata.degods.com/g/5260-dead.png",
    "price": "1.42 ETH"
  },
  {
    "id": "degods-9594",
    "name": "DeGods #9594",
    "image": "https://metadata.degods.com/g/9594-dead-rm.png",
    "price": "0.95 ETH"
  },
  {
    "id": "degods-8983",
    "name": "DeGods #8983",
    "image": "https://metadata.degods.com/g/8983-dead.png",
    "price": "1.68 ETH"
  },
  {
    "id": "degods-6609",
    "name": "DeGods #6609",
    "image": "https://metadata.degods.com/g/6609-dead-rm.png",
    "price": "1.18 ETH"
  },
  {
    "id": "degods-8469",
    "name": "DeGods #8469",
    "image": "https://metadata.degods.com/g/8469-dead-rm.png",
    "price": "0.82 ETH"
  },
  {
    "id": "degods-2729",
    "name": "DeGods #2729",
    "image": "https://metadata.degods.com/g/2729-dead-rm.png",
    "price": "1.92 ETH"
  },
  {
    "id": "degods-6580",
    "name": "DeGods #6580",
    "image": "https://metadata.degods.com/g/6580-dead-rm.png",
    "price": "1.38 ETH"
  },
  {
    "id": "degods-4071",
    "name": "DeGods #4071",
    "image": "https://metadata.degods.com/g/4071-dead-rm.png",
    "price": "0.98 ETH"
  },
  {
    "id": "degods-8702",
    "name": "DeGods #8702",
    "image": "https://metadata.degods.com/g/8702-dead-rm.png",
    "price": "1.78 ETH"
  },
  {
    "id": "degods-3085",
    "name": "DeGods #3085",
    "image": "https://metadata.degods.com/g/3085-dead-rm.png",
    "price": "1.32 ETH"
  },
  {
    "id": "degods-8607",
    "name": "DeGods #8607",
    "image": "https://metadata.degods.com/g/8607-dead-rm.png",
    "price": "0.88 ETH"
  },
  {
    "id": "degods-4527",
    "name": "DeGods #4527",
    "image": "https://metadata.degods.com/g/4527-dead-rm.png",
    "price": "2.12 ETH"
  },
  {
    "id": "degods-4007",
    "name": "DeGods #4007",
    "image": "https://metadata.degods.com/g/4007-dead-rm.png",
    "price": "1.52 ETH"
  },
  {
    "id": "degods-6169",
    "name": "DeGods #6169",
    "image": "https://metadata.degods.com/g/6169-dead.png",
    "price": "1.08 ETH"
  },
  {
    "id": "degods-4989",
    "name": "DeGods #4989",
    "image": "https://metadata.degods.com/g/4989-dead.png",
    "price": "0.72 ETH"
  },
  {
    "id": "degods-794",
    "name": "DeGods #794",
    "image": "https://metadata.degods.com/g/794-dead-rm.png",
    "price": "1.82 ETH"
  },
  {
    "id": "degods-9458",
    "name": "DeGods #9458",
    "image": "https://metadata.degods.com/g/9458-dead-rm.png",
    "price": "1.22 ETH"
  },
  {
    "id": "degods-113",
    "name": "DeGods #113",
    "image": "https://metadata.degods.com/g/113-dead-rm.png",
    "price": "0.85 ETH"
  },
  {
    "id": "degods-1392",
    "name": "DeGods #1392",
    "image": "https://metadata.degods.com/g/1392-dead-rm.png",
    "price": "1.98 ETH"
  },
  {
    "id": "degods-2806",
    "name": "DeGods #2806",
    "image": "https://metadata.degods.com/g/2806-dead.png",
    "price": "1.45 ETH"
  },
  {
    "id": "degods-9747",
    "name": "DeGods #9747",
    "image": "https://metadata.degods.com/g/9747-dead-rm.png",
    "price": "1.02 ETH"
  },
  {
    "id": "degods-7061",
    "name": "DeGods #7061",
    "image": "https://metadata.degods.com/g/7061-dead-rm.png",
    "price": "1.72 ETH"
  },
  {
    "id": "degods-6277",
    "name": "DeGods #6277",
    "image": "https://metadata.degods.com/g/6277-dead-rm.png",
    "price": "1.25 ETH"
  },
  {
    "id": "degods-1118",
    "name": "DeGods #1118",
    "image": "https://metadata.degods.com/g/1118-dead-rm.png",
    "price": "0.92 ETH"
  },
  {
    "id": "degods-5157",
    "name": "DeGods #5157",
    "image": "https://metadata.degods.com/g/5157-dead.png",
    "price": "2.18 ETH"
  },
  {
    "id": "degods-1519",
    "name": "DeGods #1519",
    "image": "https://metadata.degods.com/g/1519-dead.png",
    "price": "1.58 ETH"
  },
  {
    "id": "degods-6451",
    "name": "DeGods #6451",
    "image": "https://metadata.degods.com/g/6451-dead.png",
    "price": "1.12 ETH"
  }


    
];
